import { InputBase, styled } from '@mui/material';

export const SelectInput = styled(InputBase)(({ theme }) => ({
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    fontSize: 16,
    paddingTop: 10,
    paddingX: 2,
    textAlign: 'center',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      border: 'none',
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
